import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2026“十大渝商”评选';
const baseUrl = '0403yspxwap';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/rule`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'list',
      name: `${baseUrl}-list`,
      component: () => import('./pages/List.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'peopleDetail',
      name: `${baseUrl}-peopleDetail`,
      component: () => import('./pages/PeopleDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'link',
      name: `${baseUrl}-link,`,
      component: () => import('./pages/Link.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
  ],
};

export default route;
